<template>
    <div class="free-orders">
        <el-row>
            <el-col :span="24">
                <el-alert
                        title="温馨提示"
                        type="success"
                        close-text="知道了"
                        show-icon>
                    <p>请首先授权拼多多高佣。 <a style="color: #ff0036"
                                      href="http://admin.tk.xcx.yftaoke.com/pdd_highcommission_settings.html"
                                      target="_blank">点击去授权</a></p>
                    <p>此处生成的appid和页面路径，可以设置到首页的模块，具体可以参考界面设置的教程</p>
                    <p><a style="color: #ff0036"
                          href="https://www.yuque.com/yifakeji/irpssl/hhpo44"
                          target="_blank">界面设置教程</a></p>
                </el-alert>
                <div class="grid-content bg-purple-dark">
                    <el-form ref="form-one" :model="item" :rules="rules" label-width="150px">
                        <el-form-item label="pid">
                            <el-col :span="12">
                                <el-input v-model="item.pid" placeholder="请输入pid，不填的话走，设置的默认pid"></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="渠道类型" prop="resourceType">
                            <el-col :span="12">
                                <el-select class="form-item" v-model="item.resourceType" placeholder="请选择频道类型">
                                    <el-option
                                            v-for="item in resourceTypes"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="medium" @click="onSubmit('form-one')">生成</el-button>
                            <el-button size="medium">取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form ref="form" :model="result" label-width="150px">
                    <el-form-item label="AppId">
                        <el-col :span="12">
                            <el-input placeholder="" class="input-with-select" v-model="result.appId">
                                <el-button type="primary" slot="append"
                                           v-clipboard:copy="result.appId"
                                           v-clipboard:success="onCopy"
                                           v-clipboard:error="onError">一键复制
                                </el-button>
                            </el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="小程序页面路径">
                        <el-col :span="12">
                            <el-input placeholder="" class="input-with-select" v-model="result.pagePath">
                                <el-button type="primary" slot="append"
                                           v-clipboard:copy="result.pagePath"
                                           v-clipboard:success="onCopy"
                                           v-clipboard:error="onError">一键复制
                                </el-button>
                            </el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="网页链接">
                        <el-col :span="12">
                            <el-input placeholder="" class="input-with-select" v-model="result.shortUrl">
                                <el-button type="primary" slot="append"
                                           v-clipboard:copy="result.shortUrl"
                                           v-clipboard:success="onCopy"
                                           v-clipboard:error="onError">一键复制
                                </el-button>
                            </el-input>
                        </el-col>
                    </el-form-item>
                </el-form>

            </el-col>
        </el-row>


    </div>

</template>
<script>
    import {pddApi} from "../../common/pddApi";

    export default {
        name: 'channel',
        data() {
            return {
                item: {},
                resourceTypes: [
                    {
                        name: '限时秒杀',
                        id: 4
                    },
                    {
                        name: '充值中心',
                        id: 39997
                    },
                    {
                        name: '百亿补贴',
                        id: 39996
                    },
                    {
                        name: '火车票',
                        id: 50005
                    }
                ],
                result: {},
                rules: {
                    resourceType: [
                        {required: true, message: '请选择频道类型', trigger: 'blur'},
                    ]
                }
            }

        },
        methods: {
            onSubmit(formName) {
                var that = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        pddApi.createPddChannelPromotion.call(that, that.item, function (res) {
                            if (res.result.item) {
                                that.successMsg("生成成功");
                                that.result = res.result.item;
                                that.result.shortUrl = res.result.shortUrl
                            }
                        })
                    }
                })

            },
            onCopy() {
                this.successMsg("复制成功");
            },
            onError() {
                this.failMsg("复制失败")
            },
        }
    }

</script>
<style lang="scss">

    .form-item {
        width: 100% !important;
    }

</style>